import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-white" data-testid="terms-page">
      <Header />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-14">
        <Link
          to="/"
          className="inline-flex items-center text-slate-600 hover:text-emerald-600 mb-8 text-sm"
          data-testid="terms-back-link"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back to Home
        </Link>

        <h1 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-6">
          Terms and Conditions
        </h1>

        <div className="prose prose-slate max-w-none space-y-6 text-slate-700 leading-relaxed">
          <p>
            It is important that you review this agreement because by placing an order
            with us by telephone, WhatsApp, email, or online, you agree to the terms of
            this Agreement (the &ldquo;Agreement&rdquo;) which shall cover the terms of
            our deliveries to you and your use of our website. This Agreement is between
            you and Gorton superstore, (the &ldquo;Company&rdquo; or &ldquo;go&rdquo;)
            that states the terms and conditions under which you may use the Site and
            receive deliveries from us.
          </p>

          <section>
            <h2 className="text-xl sm:text-2xl font-semibold text-slate-900 mt-8 mb-3">
              Our Delivery Service
            </h2>
            <p>
              When you place an order, we use all reasonable effort to deliver to you
              through our own delivery service, Gorton Superstore Delivery Operations.
              Any delivery charge added to your order will be dependent upon, amongst
              other things, the value and weight of your order and the date and time of
              your delivery. If something is missing from your order, please contact us
              so that we can do everything reasonable in our power to ensure your
              satisfaction.
            </p>
            <p>
              While we are committed to delivering a seamless experience to you and
              within the guidelines of our delivery SLAs, situations outside our control
              (e.g. National Postal Strike Actions, Adverse Weather Conditions, traffic
              disruptions etc.) may impact delivery timescales.
            </p>
            <p>
              We are not liable for delays due to incorrect addresses provided to us by
              Customers. It is your responsibility to provide a correct delivery address
              and ensure that an appropriate person is available at the delivery address
              at all times during the delivery slot. Please note that Gorton Superstore
              will not accept liabilities that may arise from missed deliveries because
              of the nature of the goods supplied being fresh/frozen alongside the dry
              ones.
            </p>
            <p className="text-sm text-slate-500">
              Our site:{" "}
              <a
                href="https://www.gortonsuperstore.uk"
                className="text-emerald-600 hover:underline"
              >
                www.gortonsuperstore.uk
              </a>
            </p>
            <p>
              In the event that you instruct our own delivery service (Gorton
              Superstore Delivery Operations) to leave a delivery unattended at your
              address, Gorton Superstore expressly disclaims all liability which may
              arise by virtue of the delivery being left unattended for a period of
              time. This includes but is not limited to theft, tampering, contamination
              and the result of any change in temperature in respect of items which need
              to be kept chilled or frozen.
            </p>
            <p className="text-sm text-slate-500">
              Our site:{" "}
              <a
                href="https://www.gortonsuperstore.uk"
                className="text-emerald-600 hover:underline"
              >
                www.gortonsuperstore.uk
              </a>
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl font-semibold text-slate-900 mt-8 mb-3">
              Rescheduling Perishable Deliveries
            </h2>
            <p className="font-medium text-slate-900">
              Rescheduling perishable deliveries may result in spoilage — at your own
              risk.
            </p>
            <p>
              Perishable items are dispatched on a next-day delivery service to minimise
              spoilage. Any changes to delivery, including rescheduling or redirecting
              parcels after dispatch, are undertaken at the customer&apos;s own risk.
              Gorton Superstore accepts no liability for loss, spoilage, or damage to
              perishable goods arising from such changes or any resulting delays within
              the courier network.
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl font-semibold text-slate-900 mt-8 mb-3">
              Price and Availability
            </h2>
            <p>
              All prices are expressed inclusive of any VAT payable unless otherwise
              stated. The price of the items does not include the delivery charge which
              will be charged at the rate specified when you place your order.
            </p>
            <p>
              From time to time, products you order may be unavailable. If for any
              reason beyond our reasonable control, we are unable to supply a particular
              item, we will not be liable to you. When an item you have ordered is
              unavailable we will attempt to deliver a suitable substitute, unless you
              have asked us not to, in which case a refund will be processed for the
              item.
            </p>
          </section>
        </div>
      </div>

      <Footer />
    </div>
  );
}
